var map = {
	"./BrowseDataPoints.svg": "fa45",
	"./ContributeYourDataToBeDisplayedOnTheMap.svg": "f8ec",
	"./CustomizeYourMapView.svg": "d108",
	"./FilterThroughDataPoints.svg": "83ca",
	"./Icon-arrow.svg": "1233",
	"./Image-placeholder.svg": "ec2a",
	"./ManyOrcas.svg": "d810",
	"./ToggledHidePassword.svg": "a37f",
	"./chevron-left.svg": "254a",
	"./chevron-right.svg": "4672",
	"./close-icon.svg": "7ddb",
	"./cross.svg": "89fe",
	"./down-arrow-icon.svg": "823a",
	"./download-blue.svg": "13fa",
	"./download-icon.svg": "e3cc",
	"./edit-icon.svg": "c3a2",
	"./export-white.svg": "79aa",
	"./eye.svg": "83a42",
	"./filter-icon.svg": "9673",
	"./git-icon.svg": "eb7e",
	"./github-icon.svg": "cc4f",
	"./google.svg": "0895",
	"./hamburger-icon.svg": "9b29",
	"./hand-icon.svg": "29c7",
	"./htc-icon.svg": "2d85",
	"./hydrophone-default.svg": "811b",
	"./icon-filter.svg": "231f",
	"./info-icon.svg": "5d19",
	"./layers-icon-mobile.svg": "7ff2",
	"./layers-icon.svg": "8058",
	"./leftArrow.svg": "5a20",
	"./linkedin.svg": "953d",
	"./mail-icon.svg": "a3da",
	"./menu-about-icon.svg": "25d2",
	"./menu-account-icon.svg": "264b",
	"./menu-action-icon.svg": "534b",
	"./menu-arrow-icon.svg": "47c6",
	"./menu-contribute-icon.svg": "6251",
	"./menu-contributions-icon.svg": "bc98",
	"./menu-contributors-icon.svg": "b259",
	"./menu-delete-icon.svg": "4c79",
	"./menu-map-icon.svg": "a814",
	"./menu-reports-icon.svg": "737a",
	"./menu-sign-out-icon.svg": "b893",
	"./menu-sign-up-icon.svg": "c86f",
	"./menu-token-icon.svg": "c75a",
	"./minus.svg": "e9b2",
	"./mobile-menu-action-icon.svg": "7a3b",
	"./nav-bar-icon.svg": "1dfb",
	"./nav-profile-icon.svg": "399a",
	"./notif-msg-icon.svg": "af9d",
	"./orca.svg": "4a0e",
	"./password-eye-icon.svg": "81c0",
	"./plus-icon.svg": "adf4",
	"./plus.svg": "8a37",
	"./profile-placeholder.svg": "d52b",
	"./right-arrow.svg": "f590",
	"./right-icon.svg": "89af",
	"./rightArrow.svg": "9b18",
	"./search-icon.svg": "d8e7",
	"./sort-icon.svg": "003a",
	"./table-option-icon.svg": "5647",
	"./tick.svg": "4ab9",
	"./upload-icon.svg": "1e1e",
	"./user-reports-download-icon.svg": "843e",
	"./white-upload.svg": "c1d6",
	"./x-icon.svg": "db2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";